// API records contain JSON values. Compare their values without replacing
// reactive objects, so unchanged records retain their component identity.
export const isRecordEqual = (left, right) => {
  if (left === right) return true;
  if (
    !left ||
    !right ||
    typeof left !== 'object' ||
    typeof right !== 'object'
  ) {
    return false;
  }
  if (Array.isArray(left) !== Array.isArray(right)) return false;
  const keys = Object.keys(left);
  if (keys.length !== Object.keys(right).length) return false;
  return keys.every(
    key =>
      Object.prototype.hasOwnProperty.call(right, key) &&
      isRecordEqual(left[key], right[key])
  );
};
